// extracted by mini-css-extract-plugin
export default {"modalTitle":"RenameFormPopup_modalTitle__Nlz4P","closeModalButton":"RenameFormPopup_closeModalButton__HmMWf","buttonSection":"RenameFormPopup_buttonSection__t4WbS"};